<template>
  <div class="billingDetails">
    <img class="bg" v-if="getTheme == 0" src="@/img/mebg_diamond.png" alt />
    <div class="billingDetails_box">
      <div class="billingDetails_nav">
        <div class="billingDetails_nav_url" @click="ret">
          <img
            class="billingDetails_nav_img"
            :src="require('@/img/' + getTheme + '-back.png')"
            alt=""
          />
          <!-- <img
            class="billingDetails_nav_img"
            src="@/img/tag_tab_return_1.png"
            alt
          /> -->
        </div>
        <div class="billingDetails_nav_text">
          {{ $t("Pay.Billing_Breakdowns") }}
        </div>
      </div>
    </div>
    <div class="billingDetails_centent">
      <div class="navigation">
        <div class="navigation_Billing" @click="selectNav(1)">
          <div
            class="navigation_Topup"
            :class="listindex == 1 ? 'navigation_active' : ''"
          >
            {{ $t("Pay.Topup") }}
            <div class="navigation_active_chunk"></div>
          </div>
        </div>
        <div class="navigation_Billing" @click="selectNav(2)">
          <div
            class="navigation_Topup"
            :class="listindex == 2 ? 'navigation_active' : ''"
          >
            {{ $t("Pay.Consumption") }}
            <div class="navigation_active_chunk"></div>
          </div>
        </div>
      </div>

      <keep-alive>
        <topup v-if="listindex == 1"></topup>
        <consumption v-if="listindex == 2"></consumption>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

import consumption from "@/components/billing/consumption";
import topup from "@/components/billing/topup";
import configs from "@/config/config.js";
export default {
  components: {
    topup,
    consumption
  },
  data() {
    return {
      listindex: 1,
      getTheme: ""
    };
  },
  created() {
    this.getTheme = configs.getTheme();
  },
  methods: {
    selectNav(index) {
      var self = this;
      self.listindex = index;
    },
    // 后退
    ret() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped="scoped">
.billingDetails {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
}
.billingDetails_box {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 2;
}

.billingDetails_nav {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 1.44rem;
  position: relative;
}

.billingDetails_nav_url {
  box-sizing: border-box;
  width: 1.2rem;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  padding-left: 0.54rem;
  display: flex;
  align-items: center;
}
.billingDetails_nav_img {
  width: 0.33rem;
  height: 0.54rem;
}
.billingDetails_nav_text {
  font-size: 0.54rem;
  color: var(--navColor);
}
.billingDetails_centent {
  position: absolute;
  top: 1.77rem;
  left: 0;
  z-index: 2;
  bottom: 0;
  width: 100%;
  height: auto;
  overflow: auto;
  background-color: var(--bg);
  border-radius: 0.48rem 0.48rem 0 0;
  padding: 0.44rem 0.49rem 0 0.39rem;
}

.navigation {
  height: 1.5rem;
  width: 100%;
  display: flex;
  justify-content: center;
}

.navigation_Billing {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 0.75rem;
}

.navigation_Topup {
  color: var(--billingNavColor);
  font-size: 0.42rem;
}
.navigation_active {
  color: var(--billingNavColorActive);
  display: flex;
  flex-direction: column;
  align-items: center;
}
.navigation_active_chunk {
  margin-top: 0.12rem;
  width: 0.19rem;
  height: 0.1rem;
  border-radius: 0.6rem;
}
.navigation_active .navigation_active_chunk {
  background-color: var(--billingNavBackgroundChunkActive);
}
</style>



// WEBPACK FOOTER //
// src/components/billingDetails.vue